import type React from 'react'

import { useOpenUpgradeModal } from '../../../../hooks'
import { ActionButton, ActionsMessage } from '../../../index'

// v2 (chat-agent): the agent emits suggest_actions(['upgrade']) whenever it tells
// the user a feature needs a paid plan. Render an Upgrade chip that opens pricing
// — same flow as PaywallMessage and the action-limit Upgrade.
export const UpgradeActionsMessage: React.FC = () => {
  const onUpgradeClick = useOpenUpgradeModal()

  return (
    <ActionsMessage>
      <ActionButton variant="purple" onClick={onUpgradeClick}>
        Upgrade
      </ActionButton>
    </ActionsMessage>
  )
}
